export const tooltipRefash = (
  myChart,
  dataLen,
  delay = 5000,
  seriesIndexFlag = true
) => {
  let app = {};
  app.currentIndex = -1;
  let timer = setInterval(() => {
    // let dataLen = option.series[0].data.length;
    //取消之前高亮的图形
    myChart.dispatchAction({
      type: 'downplay',
      seriesIndex: seriesIndexFlag ? 0 : app.currentIndex,
      dataIndex: seriesIndexFlag ? app.currentIndex : 0,
    });
    app.currentIndex = (app.currentIndex + 1) % dataLen;
    //高亮当前图形
    myChart.dispatchAction({
      type: 'highlight',
      seriesIndex: seriesIndexFlag ? 0 : app.currentIndex,
      dataIndex: seriesIndexFlag ? app.currentIndex : 0,
    });
    //显示tooltip
    myChart.dispatchAction({
      type: 'showTip',
      seriesIndex: seriesIndexFlag ? 0 : app.currentIndex,
      dataIndex: seriesIndexFlag ? app.currentIndex : 0,
    });
  }, delay);
  return timer;
};
